/// <amd-module name="VC/Common/Utils/Ref" />

const refsHeadsPrefix = "refs/heads/";
const refsTagsPrefix = "refs/tags/";

export function getFriendlyName(refName: string): string {
    if (isBranch(refName)) {
        return refName.substr(refsHeadsPrefix.length);
    } else if (isTag(refName)) {
        return refName.substr(refsTagsPrefix.length);
    } else {
        return refName;
    }
}

export function getRefNameFromBranchName(branchName: string): string {
    return refsHeadsPrefix + branchName;
}

export function getRefNameFromTagName(branchName: string): string {
    return refsTagsPrefix + branchName;
}

export function isBranch(refName: string): boolean {
    return (refName || "").indexOf(refsHeadsPrefix) === 0;
}

export function isTag(refName: string): boolean {
    return (refName || "").indexOf(refsTagsPrefix) === 0;
}

// This function is temporary while we migrate VersionSpec to LWP.
export function getVersionFromBranchName(name: string): string {
    return "GB" + name;
}

// This function is temporary while we migrate VersionSpec to LWP.
export function getVersionFromTagName(name: string): string {
    return "GT" + name;
}

// This function is temporary while we migrate VersionSpec to LWP.
export function getVersionFromCommitHash(full: string): string {
    return "GC" + full;
}

export function getShortCommitId(full: string): string {
    return full.substring(0, 8);
}